<template>
    <div>
        <label for="group_id" class="form-label">
            Group
        </label>

        <v-select
            v-model="selectedGroup"
            :options="groups"
            label="name"
            placeholder="Select a Group"
            :reduce="group => group"
            :disabled="groups.length <= 1"
        />

        <input type="hidden" name="group_id" :value="selectedGroup ? selectedGroup.id : ''">
    </div>
</template>

<script>
import VSelect from 'vue-select';

export default {
    props: {
        groups: {
            type: Array,
            required: true,
        },
    },

    components: {
        VSelect
    },

    data() {
        return {
            selectedGroup: {},
        }
    },

    mounted() {
        if (this.groups.length === 1) {
            this.selectedGroup = this.groups[0];
        }
    },

    watch: {
        selectedGroup(newValue) {
            this.$emit('group-changed', newValue || null)
        }
    }
}
</script>
